import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

interface DocumentPDFButtonProps {
    title: string;
    record: any;
    fileName?: string;
}

export const DocumentPDFButton = ({ title }: DocumentPDFButtonProps) => {
    return (
        <Button variant="outline" size="sm" onClick={() => window.print()}>
            <Printer className="w-4 h-4 mr-2" />
            Print / Download {title || 'PDF'}
        </Button>
    );
};
